module.exports = __webpack_public_path__ + "img/google-authenticator.193ac1a1.svg";